import { Modal } from "@circleco/compass/components/Modal";
import type { ReactNode } from "react";

import { t } from "@/i18n-js/instance";

interface DeleteConversationModalProps {
  confirmText: string;
  description: ReactNode;
  isDeleting: boolean;
  isOpen: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  title: string;
}

export const DeleteConversationModal = ({
  confirmText,
  description,
  isDeleting,
  isOpen,
  onCancel,
  onConfirm,
  title,
}: DeleteConversationModalProps) => (
  <Modal.Root
    open={isOpen}
    onOpenChange={(open: boolean) => {
      if (!open) {
        onCancel();
      }
    }}
  >
    <Modal.Content>
      <Modal.Header title={title} showCloseButton={!isDeleting} />
      <Modal.Body>{description}</Modal.Body>
      <Modal.Footer
        secondaryAction={
          isDeleting
            ? undefined
            : {
                label: t("cancel"),
                onClick: onCancel,
                shouldCloseModal: false,
              }
        }
        primaryAction={{
          label: confirmText,
          variant: "destructive",
          loading: isDeleting,
          onClick: onConfirm,
          type: "button",
        }}
      />
    </Modal.Content>
  </Modal.Root>
);
